import React from 'react';
import { Button } from '../../../ui/Button';
import { DocumentUploader } from './Documents/DocumentUploader';
import { useDocuments } from '../../../../hooks/useDocuments';
import { useParams } from 'react-router-dom';

interface DocumentsProps {
  onSave: () => void;
}

export const Documents: React.FC<DocumentsProps> = ({ onSave }) => {
  const { id: propertyId } = useParams<{ id: string }>();
  const { documents: savedDocuments, isLoading, deleteDocument, loadDocuments } = useDocuments(propertyId ? parseInt(propertyId) : undefined);

  const handleDelete = async (documentId: number) => {
    if (window.confirm('Voulez-vous vraiment supprimer ce document ?')) {
      const success = await deleteDocument(documentId);
      if (success && propertyId) {
        loadDocuments(parseInt(propertyId));
      }
    }
  };

  const handleUploadComplete = () => {
    if (propertyId) {
      loadDocuments(parseInt(propertyId));
    }
  };

  return (
    <div className="space-y-6">
      <DocumentUploader onUploadComplete={handleUploadComplete} />

      {isLoading && (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto"></div>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">Chargement des documents...</p>
        </div>
      )}

      {/* Documents sauvegardés en base */}
      {!isLoading && savedDocuments.length > 0 && (
        <div className="space-y-4">
          <h4 className="font-medium text-gray-900 dark:text-white">
            Documents ({savedDocuments.length})
          </h4>
          <div className="space-y-2">
            {savedDocuments.map(doc => (
              <div key={doc.id} className="flex items-center justify-between rounded-lg border border-gray-200 p-3 dark:border-gray-700">
                <div className="flex-1">
                  <p className="font-medium text-gray-900 dark:text-white">
                    {doc.original_filename}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {(doc.file_size / 1024 / 1024).toFixed(2)} MB
                  </p>
                </div>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => {
                      const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';
                      const documentUrl = `${baseUrl}/documents/${doc.id}/download`;
                      window.open(documentUrl, '_blank');
                    }}
                  >
                    Ouvrir
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(doc.id)}
                  >
                    Supprimer
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!isLoading && savedDocuments.length === 0 && (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
          <p>Aucun document ajouté</p>
        </div>
      )}

      <div className="flex justify-end">
        <Button onClick={onSave}>
          Enregistrer
        </Button>
      </div>
    </div>
  );
};
